export const useLocalStorage = () => {
    const setItem = (value = "", key = '') => {
        try {
            window.localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            throw error instanceof Error ? error : new Error(String(error));
        }
    };

    const getItem = (key = '') => {
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : undefined;
        } catch (error) {
            console.log(error instanceof Error ? error.message : String(error));
        }
    };

    const removeItem = (key = '') => {
        try {
            window.localStorage.removeItem(key);
        } catch (error) {
            console.log(error instanceof Error ? error.message : String(error));
        }
    };

    return { setItem, getItem, removeItem };
};